export interface CabinClass {
  $id: string;
  Value: string;
  Description: string;
}

export class CabinClassesConstant {
  cabinClasses = [
    {
      $id: '2',
      Value: 'Economy',
      Description: 'Economy',
    },
    {
      $id: '3',
      Value: 'PremiumEconomy',
      Description: 'Premium Economy',
    },
    {
      $id: '4',
      Value: 'Business',
      Description: 'Business',
    },
    {
      $id: '5',
      Value: 'First',
      Description: 'First',
    },
  ] as CabinClass[];
}
